<div class="container">
    <!-- 1. Explicit App & Developer Identification -->
    <h1>Account & Data Deletion Request</h1>
    <p>This form allows you to request the permanent deletion of your account and associated data for the app <span class="app-name">TTMS Fuel Dispenser</span> developed by <span class="app-name">ERFS</span>.</p>

    <!-- 2. Explanation of Data Implications -->
    <div class="warning-box">
        <strong>What happens when your account is deleted?</strong>
        <ul>
            <li>Your profile information and login details will be permanently removed.</li>
            <li>All saved app settings, progress, and history will be deleted.</li>
        </ul>
    </div>

    <!-- 3. Deletion Request Form -->
    <div>
        
        <div class="form-group">
            <label for="email">Registered Email Address:</label>
            <input 
                type="email"
                maxlength="50"
                placeholder="alex@example.com" 
                [(ngModel)]="email"
            />
        </div>

        <div class="checkbox-group">
            <input 
                type="checkbox" 
                id="confirm" 
                name="confirm"
                [(ngModel)]="isChecked"
            />
            <label for="confirm">I understand that account deletion is irreversible and all non-legally mandated data will be deleted within 30 days.</label>
        </div>

        <button (click)="submitRequest()">Submit Deletion Request</button>
    </div>
</div>
